import { ActuacionContractual } from './actuacion-contractual.interface';
import { ActuacionContractualDto } from './actuacion-contractual.dto';

export class ActuacionContractualMapper {
  static fromDto(dto: ActuacionContractualDto): ActuacionContractual {
    return {
      actuacionId: dto.actuacion_ID,
      tipo: dto.tipo,
      estado: dto.estado
    };
  }

  static fromDtoList(dtos: ActuacionContractualDto[]): ActuacionContractual[] {
    return dtos.map(dto => this.fromDto(dto));
  }

  static toDto(model: ActuacionContractual): ActuacionContractualDto {
    return {
      actuacion_ID: model.actuacionId,
      tipo: model.tipo,
      estado: model.estado
    };
  }
}
